import { IHomepage } from '@viabizzuno/models';
import { getLayout } from '@viabizzuno/models/server';
import { LayoutDefault } from '@viabizzuno/ui';
import { getPageProps } from '@viabizzuno/ui/server';
import { asEquatable, IStaticContext, PageProps } from '@websolutespa/bom-core';
import { getPage, getStaticPathsForSchema } from '@websolutespa/bom-mixer-models/server';
import { LazyLoader, OpenGraph, StructuredData } from '@websolutespa/bom-mixer-ui';
import { GetStaticPropsResult } from 'next';

export default function Homepage({ layout, page, params }: PageProps<IHomepage>) {
  return (
    <>
      <LazyLoader components={page.components} />
      <StructuredData />
      <OpenGraph item={(metaData) => ({
        ...metaData.openGraph,
        image: page.media?.url,
      })} />
    </>
  );
}

Homepage.Layout = LayoutDefault;

export async function getStaticProps(context: IStaticContext): Promise<GetStaticPropsResult<PageProps<IHomepage>>> {
  const id = asEquatable(context.params.id);
  const market = context.params.market;
  const locale = context.params.locale;
  const layout = await getLayout(market, locale);
  const page = await getPage<IHomepage>('homepage', id, market, locale, context);
  if (!page) {
    return {
      notFound: true,
      revalidate: true,
    };
  }
  page.header_type = 'overlap';
  const props = await getPageProps({ ...context, layout, page });
  return {
    props,
    /*
    * Next.js will attempt to re-generate the page when a request comes in at most once every 60 seconds
    */
    revalidate: 60 * 60 * 2, // revalidate
  };
}

export async function getStaticPaths() {
  const paths = await getStaticPathsForSchema('homepage');
  return {
    paths,
    fallback: 'blocking', // runs before initial render
    // fallback: true, // runs in the background
  };
}
